import dom, { Fragment } from "jsx-render";

const SettingsView = () => {
  let userdata = window.config.getUserdata();
  return (
    <div class="container page login">
      <div class="row">
        <h1>Account</h1>
        <h3 id="user-form-msg" />
        <form
          id="user-form"
          className="user-form"
          role="form"
          method="POST"
          action="/account"
        >
          <div className="form-group">
            <label className="col-md-4 control-label">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              value={userdata.email}
            />
            <span className="help-block" />
          </div>

          <div className="form-group">
            <label className="col-md-4 control-label">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              id="password"
              autocomplete="new-password"
            />
            <span className="help-block" />
          </div>
          <div className="form-group">
            <label className="col-md-4 control-label">
              Additional details (such as your VAT number, etc) to appear on
              your invoice
            </label>
            <textarea
              rows="5"
              className="form-control"
              name="invoice_data"
              id="invoice_data"
            >
              {userdata.invoice_data}
            </textarea>
            <span className="help-block" />
          </div>

          <div className="form-group">
            <div className="col-md-6 col-md-offset-4">
              <button type="submit" className="btn btn-primary btn-full-width">
                Update
              </button>
              <span className="load" style={{ display: "none" }}>
                {" "}
                <img src="/images/preloader.gif" />
              </span>
            </div>
          </div>
        </form>

        <h1>Subscription details</h1>

        {!userdata.hasSubscription ? (
          <ul className="info" id="subscsription-inactive">
            <li>You have no active subscription.</li>
          </ul>
        ) : (
          <div>
            <ul className="info" id="subscription-active">
              <li>
                <span className="label">Current subscription:</span>
                <div id="stripe-info-period">{userdata.stripeInfoPeriod}</div>
                <span className="loader">
                  <img src="https://claro55.localhost/images/Spinning-wheel-icon-white.svg" />
                </span>
              </li>
              <li>
                <span className="label">Amount:</span>
                <div id="stripe-info-amount">
                  {!userdata.hasCard && userdata.hasSubscription
                    ? "on trial"
                    : userdata.stripeInfoAmount}
                </div>
                <span className="loader">
                  <img src="https://claro55.localhost/images/Spinning-wheel-icon-white.svg" />
                </span>
              </li>
            </ul>

            <form id="change-subscription-form">
              <div className="form-group">
                <div className="col-md-6 col-md-offset-4">
                  {userdata.stripeMessage ? (
                    <div id="change-sub-msg">
                      Your subscription was successfully updated
                    </div>
                  ) : (
                    <button
                      id="change-sub-btn"
                      type="submit"
                      className="btn btn-primary btn-full-width"
                    >
                      <span className="loader">
                        <img src="https://claro55.localhost/images/Spinning-wheel-icon-white.svg" />
                      </span>
                      {userdata.stripeInfoInterval == "month" ? (
                        <span>Switch to annual billing ($50 /year)</span>
                      ) : (
                        <span>Switch to monthly billing ($5 /month)</span>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        )}

        <h3>Card details</h3>

        {!userdata.hasCard && userdata.hasSubscription ? (
          <ul className="info" id="card-missing">
            <li>You have no active card.</li>
          </ul>
        ) : (
          <ul className="info" id="card-present">
            <li>
              <span className="label">Brand:</span>
              <span id="stripe-info-brand" />
              {userdata.stripeInfoBrand}
            </li>
            <li>
              <span className="label">Number:</span>
              <span id="stripe-info-number" />
              {userdata.stripeInfoNumber}
            </li>
            <li>
              <span className="label">Expires:</span>
              <span id="stripe-info-exp" />
              {userdata.stripeInfoExp}
            </li>
          </ul>
        )}

        {userdata.hasCard ? (
          <div>
            <h1>Update payment details</h1>
            <h3 id="payment-form-msg" />
            <div id="paymentupdate">
              <form id="payment-form" action="/stripe/update" method="post">
                <div className="row" style="display:none;">
                  <p className="payment-errors" />
                </div>

                <div className="form-group">
                  <div className="col-md-6 col-md-offset-4">
                    <button
                      type="submit"
                      className="btn btn-primary btn-full-width"
                    >
                      Update
                    </button>
                    <span className="load" style={{ display: "none" }}>
                      <img src="/images/preloader.gif" />
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        ) : (
          ""
        )}

        <h1>Close account</h1>
        <a id="delete link" href="delete">
          Delete account permanently
        </a>

        <div className="version" />
      </div>
    </div>
  );
};

export default SettingsView;
